import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import VideoKeywordDetailLive from './VideoKeywordDetailLive'

function VideoKeywordContainerLive() {
  return (
    <MainLayout navTitle={"Video Keyword Details"} navSubTitle={"Welcome to ImagesBazaar"}>
      <VideoKeywordDetailLive/>
    </MainLayout>
  )
}

export default VideoKeywordContainerLive